import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
  collection,
  DocumentData,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { auth, db } from 'src/services/firebase-service';
import logging from 'src/services/logging';

const useUser = () => {
  const [user, loading, error] = useAuthState(auth);
  const [fetchingUser, setFetchingUser] = useState<boolean>(true);
  const [dbUser, setDbUser] = useState<DocumentData>();

  useEffect(() => {
    const getUser = async () => {
      if (error) {
        logging.error(error.message, 'useUser');
        return;
      }
      if (user) {
        logging.info(`Get user ${user.displayName} from db`, 'useUser');
        const q = query(collection(db, 'users'), where('uid', '==', user.uid));
        const snapshot = await getDocs(q);
        setDbUser(snapshot.docs[0].data());
      }
      setFetchingUser(false);
    };
    if (!loading) {
      getUser();
    }
  }, [user, loading, error]);

  return {
    error,
    fetchingUser,
    dbUser,
  };
};

export default useUser;
